import { Close, Person } from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

interface ScanMenuProps {
	onClose: () => void;
}

const ScanMenu: React.FC<ScanMenuProps> = ({ onClose }) => {
	const navigate = useNavigate();

	const buttomItems = [
		{ icon: Person, title: "出旗袋", link: "/camera?scanType=2" },
		{ icon: Person, title: "實收袋", link: "/camera?scanType=3" },
		{ icon: Person, title: "收吉袋", link: "/camera?scanType=4" },
		{ icon: Person, title: "實收袋&入銀行", link: "/camera?scanType=5" },
	];

	return (
		<>
			<Box
				id="footer"
				className={"footer"}>
				<Box className="button-container">
					<Grid
						container
						spacing={2}
						rowSpacing={4}>
						{buttomItems.map((item) => {
							return (
								<Grid
									key={item.title}
									size={6}
									className="item">
									<IconButton
										onClick={() => navigate(item.link, { replace: true })}
										sx={{ backgroundColor: "rgb(4, 3, 37)", color: "primary.contrastText", mb: 0.5 }}>
										<item.icon fontSize="large"></item.icon>
									</IconButton>
									<Typography fontWeight={"500"}>{item.title}</Typography>
								</Grid>
							);
						})}
					</Grid>
				</Box>
				<Box className="close-button">
					<IconButton onClick={onClose}>
						<Close fontSize="large" />
					</IconButton>
				</Box>
			</Box>
			<Box
				id="dropback"
				className={"dropback"}
				onClick={onClose}
			/>
		</>
	);
};

export default ScanMenu;

